// src/services/servicos/OrdemServicoService.js
import {
  fetchBlobData,
  fetchData,
  postData,
  putData,
} from '../Api';
import { OrdemServicoFiltroAvancado } from '../../models/servicos/OrdemServicoFiltroAvancado';

export const listarOrdensServico = (filtros = {}) => fetchData('/OrdemServico', {
  ...filtros,
  ...new OrdemServicoFiltroAvancado(filtros).paraParametros(),
});
export const obterOrdemServico = id => fetchData(`/OrdemServico/${id}`);
export const obterOrdemServicoDetalhada = id => fetchData(
  `/OrdemServico/GetOrdemServicoDetalhada/${id}`,
);
export const obterPdfOrdemServico = (id, paperWidthMm = 75) => fetchBlobData(
  `/OrdemServico/${id}/impressao`,
  { paperWidthMm },
);
export const criarOrdemServico = dados => postData('/OrdemServico', dados);
export const atualizarOrdemServico = (id, dados) => putData(`/OrdemServico/${id}`, dados);
export const executarAcaoOrdemServico = (id, acao, dados) => postData(`/OrdemServico/${id}/${acao}`, dados);
export const aprovarOrdemServico = (id, dados) => postData(`/OrdemServico/${id}/aprovar`, dados);
export const prepararFaturamentoOrdensServico = ordensServicoIds => postData(
  '/OrdemServico/preparar-faturamento',
  { ordensServicoIds },
);
export const faturarOrdensServicoLote = dados => postData(
  '/OrdemServico/faturar-lote',
  dados,
);
export const enviarDocumentosFiscaisWhatsApp = ordensServicoIds => postData(
  '/OrdemServico/enviar-documentos-whatsapp',
  { ordensServicoIds },
);
